import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material';
import { Router } from '@angular/router';
import { DataTableDirective } from 'angular-datatables';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { Subject } from 'rxjs';
import { BackendApiService } from 'src/app/service/backendapi.service';
import { DataSharingService } from 'src/app/service/data-sharing.service';
import { EndpointsService } from 'src/app/service/endpoints.service';
import { DeleteWhitelistComponent } from '../dialog/delete-whitelist/delete-whitelist.component';
import { UpdateWhitelistComponent } from '../dialog/update-whitelist/update-whitelist.component';
import * as XLSX from 'xlsx'
import { ExportToCsv } from 'export-to-csv';

@Component({
  selector: 'app-whitelist-data-table',
  templateUrl: './whitelist-data-table.component.html',
  styleUrls: ['./whitelist-data-table.component.scss']
})
export class WhitelistDataTableComponent implements OnInit {
  @ViewChild(DataTableDirective, { static: false }) dtElement: DataTableDirective;
  dtOptions: any = {};
  dtTrigger: Subject<any> = new Subject();
  @Input() tableData: any;
  @Output() refreshTableData = new EventEmitter();
  title:any='whitelist';
  fileName:any;
  dataToBeDownloaded: any =[];

  constructor(private dialog: MatDialog,private dataSharingService: DataSharingService,private spinnerService: Ng4LoadingSpinnerService,
    private endpointsService: EndpointsService,private router: Router,
    private backendApiService: BackendApiService) { }

  ngOnInit(): void {

    for(var i=0; i<=this.tableData.length-1 ; i++)
    {
      this.dataToBeDownloaded.push({'S No.': this.tableData[i].sno ,MSISDN: this.tableData[i].msisdn ,
        IMSI: this.tableData[i].imsi, Remarks: this.tableData[i].remarks , 'Message Type': this.tableData[i].message_type});
      

    }
    
    console.log("this.dataToBeDownloaded",this.dataToBeDownloaded)
    this.dtOptions = {
      paging: true,
      pagingType: 'full_numbers',
      scroller: true,
      scrollCollapse: true,
      scrollX: true,
      responsive: true,
      select: true,
      dom: '<\'row\'<\'col-sm-12 col-md-3\'l><\'col-sm-12 col-md-3\'B><\'col-sm-12 col-md-6\'f>>' +
        '<\'row\'<\'col-sm-12\'tr>>' +
        '<\'row\'<\'col-sm-12 col-md-3 entries\'i><\'col-sm-12 col-md-9 entries\'p>>',
        buttons: [
          {
            text: 'CSV',
            action: () => {
              
              this.downloadcsv(this.dataToBeDownloaded , this.title);
              this.storeAnalytics();
            },
            exportOptions: {
              columns: [0,1,2,3,4]
            } 
          },
          { 
            text: 'EXCEL',
          action: () => {
            
            this.exportTable(this.title);
            this.storeAnalytics();
          },
          exportOptions: {
            columns: [0,1,2,3,4]
          }

          
          }
        ],
      // columnDefs: [{
      //   targets: [11], // column or columns numbers
      //   orderable: false  // set orderable for selected columns
      // }]
    };
  }
  public downloadcsv(serviceSummaryData, title) {
    console.log('serviceSummaryData ', serviceSummaryData);
    var data1 = document.getElementById('view-table');
    const options = {
      filename: title,
      fieldSeparator: ',',
      quoteStrings: '"',
      decimalSeparator: '.',
      useTextFile: false,
      useBom: true,
      useKeysAsHeaders: true,
      // headers: ['Column 1', 'Column 2', etc...] <-- Won't work with useKeysAsHeaders present!
    };
    const csvExporter = new ExportToCsv(options);
    csvExporter.generateCsv(serviceSummaryData);
  }
  
  exportTable(title) {
    const workSheet = XLSX.utils.json_to_sheet(this.dataToBeDownloaded);
    const workBook: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workBook, workSheet, 'SheetName');
    XLSX.writeFile(workBook, title+'.xlsx');
}

  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }

  rerender(): void {
    this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
      // Destroy the table first
      dtInstance.destroy();
      // Call the dtTrigger to rerender again
      this.dtTrigger.next();
    });
  }

  ngAfterViewInit(): void {
    this.dtTrigger.next();
  }

  update(row: any){
    const dialogRef = this.dialog.open(UpdateWhitelistComponent, {
      width: '900px',
        panelClass: 'custom-modalbox',
      data: {rowData: row},
      // panelClass: 'custom-modalbox',
      disableClose: true
    });

    dialogRef.afterClosed().subscribe(result => {
      
      this.refreshTableData.emit();
    });
  }

  deleteRow(item: any){
    const deleteDialogRef = this.dialog.open(DeleteWhitelistComponent, {
      width: '350px',
      data: {urlDelete: this.endpointsService.URL_DELETE_WHITELIST
      + '&sno=' + item.sno,item},
      disableClose: true
    });    

    deleteDialogRef.afterClosed().subscribe(result => {
      
      if (result === true) {
        this.refreshTableData.emit();
      }

    });
  }
  storeAnalytics() {
    const apiUrl1 = this.endpointsService.CENTRY_LOG +
        'userName=' + sessionStorage.getItem('ecowas_user_name') + '&action=Whitelist' + '&module=Whitelist' + '&operation=download' + '&opname=is_downloaded' + '&opvalue=true';
      this.backendApiService.callToApi(apiUrl1).subscribe(response => {
       console.log(response);
      });
  
    }

}
